import { render } from "./PuzzleTypeListView.vue?vue&type=template&id=2eefaa58&scoped=true"
import script from "./PuzzleTypeListView.vue?vue&type=script&lang=js"
export * from "./PuzzleTypeListView.vue?vue&type=script&lang=js"

import "./PuzzleTypeListView.vue?vue&type=style&index=0&id=2eefaa58&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eefaa58"]])

export default __exports__